import { isResponseRetry } from '@app/utils/predicates'

import SFetch from '@app/utils/sfetch'

export const fetchAccounts = ({ companyId } = {}) =>
  SFetch.json(
    window.Silverfin.Routes.accounts_path({
      firm_id: window.Silverfin.currentFirmId,
      company_id: companyId || window.Silverfin.currentCompanyId,
    })
  )

export const fetchAccountGroups = () =>
  SFetch.json(
    window.Silverfin.Routes.chart_of_accounts_accounts_path({
      firm_id: window.Silverfin.currentFirmId,
      company_id: window.Silverfin.currentCompanyId,
    })
  )

export const fetchMappingProposals = () =>
  SFetch.json(
    window.Silverfin.Routes.mapping_proposals_accounts_path({
      firm_id: window.Silverfin.currentFirmId,
      company_id: window.Silverfin.currentCompanyId,
    })
  )

export const fetchAccountBalances = () =>
  SFetch.json(
    window.Silverfin.Routes.ledger_account_entries_path({
      firm_id: window.Silverfin.currentFirmId,
      company_id: window.Silverfin.currentCompanyId,
      ledger_id: window.Silverfin.currentLedgerId(),
    })
  )

export const waitForAIScheduling = async () => {
  const path = window.Silverfin.Routes.schedule_mapping_proposal_accounts_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId
  )

  await SFetch.withRetry(SFetch.json, {
    maxRetries: 5,
    shouldRetry: isResponseRetry,
  })(path)
}
